import { render } from "./HomeHRD.vue?vue&type=template&id=448bb7b8"
import script from "./HomeHRD.vue?vue&type=script&lang=js"
export * from "./HomeHRD.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__